import React, { Component } from 'react'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'

import { Button } from 'components/misc'
import { Title } from 'components/layout'
import { modal } from 'redux/modules/app'
import { form } from 'helpers/decorators'

const enhance = compose(
  connect(null, { modal }),
  form({
    form: 'request-additional-info',
  })
)

class TaskRequestAdditionalInfo extends Component {
  static propTypes = {
    onClose: PropTypes.func,
    modal: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    person: PropTypes.any,
  }

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose()
      return
    }

    this.props.modal(null)
  }


  render() {
    const {
      handleSubmit,
      person,
    } = this.props

    return (
      <form
        onSubmit={handleSubmit(() => this.props.onClose())}
      >
        <Title h2 intlKey="moduleTitle.email_addresses_of_selected_participants">
          Which email address you want to use?
        </Title>
        <div className="row">
          {[person.email, person.secondaryEmail, person.tertiaryEmail].map((v, i) => (
            <div key={i} className="col-xs-12" style={{ marginBottom: 5 }}>
              <a href={`mailto:${v}`}>{v}</a>
            </div>
          ))}
          <div className="col-xs-12 text--center">
            <Button type="button" onClick={this.handleClose} secondary>
              <FormattedMessage id="button.close" defaultMessage="Close" />
            </Button>
          </div>
        </div>
      </form>
    )
  }
}

export default enhance(TaskRequestAdditionalInfo)
